// TODO Django 4: Solution with calculateTitleHeight should be reworked
export default class C025Quicklinks {
  constructor(node, props) {
    this.node = node;
    this.props = props;
    this.id = props.id;
  }

  init() {
    this.calculateTitleHeight();
    this.initFilters();
  }

  calculateTitleHeight() {
    const quickLinkTexts = this.node.querySelectorAll('[data-component-part="quicklink-link-text"]');
    let minHeight = 0;

    quickLinkTexts.forEach((component) => {
      component.style.minHeight = 0;
      minHeight = Math.max(minHeight, component.getBoundingClientRect().height);
    });

    quickLinkTexts.forEach((component) => {
      component.style.minHeight = minHeight + 'px';
    });
  }

  ready() {
    this.init();
  }

  windowResize() {
    this.calculateTitleHeight();
  }

  clear() { }

  cmsRefresh() {
    this.calculateTitleHeight();
  }

  initFilters() {
    const filterButtonGroups = this.node.querySelectorAll('[data-component-part="filter-button-group"]');
    const filterDropdowns = this.node.querySelectorAll('[data-component-part="filter-select"]');
    const filterItems = this.node.querySelectorAll('[data-component-part="quicklink"]');
    const filterItemsArray = Array.from(filterItems);
    const currentFilters =  {};

    const applyFilter = (filter, groupId) => {
      currentFilters[groupId] = filter;

      filterItemsArray.forEach((item) => {
        const dataIds = item.dataset.filterIds.split(' ');
        let visible = false;

        for (const group in currentFilters) {
          const currentFilter = currentFilters[group];

          if (currentFilter === '') {
            visible = true;
          } else if (dataIds.includes(currentFilter)) {
            visible = true;
          } else {
            visible = false;
            break;
          }
        }
        if (visible) {
          item.parentNode.style.display = 'block';
        } else {
          item.parentNode.style.display = 'none';
        }
      });
    };

    filterButtonGroups.forEach((group) => {
      const buttons = group.querySelectorAll('[data-component-part="filter-button"]');
      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          const filter = event.target.dataset.filter;
          applyFilter(filter, group.getAttribute('id'));
          buttons.forEach((btn) => {
            btn.classList.remove('active');
          });
          event.target.classList.add('active');
        });
      });
    })

    filterDropdowns.forEach((dropdown) => {
      dropdown.addEventListener('change', (event) => {
        const filter = event.target.value;
        const groupId = dropdown.getAttribute('id');
        applyFilter(filter, groupId);
      });
    });
  }
}
